"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.68738 4.66634C1.29155 5.08301 1.22905 5.33301 1.29155 6.68717L1.35405 8.22884L2.16655 8.35384C4.27072 8.68717 4.27072 11.3122 2.16655 11.6455L1.35405 11.7705L1.29155 13.3747C1.22905 14.8747 1.27072 14.9788 1.79155 15.3955C2.33322 15.8122 2.54155 15.833 10.0416 15.833H17.729L18.2499 15.3122C18.729 14.833 18.7707 14.6663 18.7082 13.2913L18.6457 11.7705L17.8332 11.6455C15.729 11.3122 15.729 8.68717 17.8332 8.35384L18.6457 8.22884L18.7082 6.74967C18.7499 5.52051 18.6874 5.18717 18.3332 4.72884L17.8957 4.16634H10.0207H2.14572L1.68738 4.66634ZM17.4999 6.35384C17.4999 7.14551 17.4374 7.29134 17.104 7.29134C16.4582 7.29134 15.4374 8.29134 15.1874 9.18717C14.9999 9.81217 14.9999 10.1872 15.1874 10.8122C15.4374 11.708 16.4582 12.708 17.104 12.708C17.4374 12.708 17.4999 12.8538 17.4999 13.6455V14.583H9.99988H2.49988V13.6455C2.49988 12.8538 2.56238 12.708 2.89572 12.708C3.54155 12.708 4.56238 11.708 4.81238 10.8122C4.99988 10.1872 4.99988 9.81217 4.81238 9.18717C4.56238 8.29134 3.54155 7.29134 2.89572 7.29134C2.56238 7.29134 2.49988 7.14551 2.49988 6.35384V5.41634H9.99988H17.4999V6.35384Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.29157 7.39553C6.97907 7.77053 7.08323 8.33303 7.5624 8.6247C8.27073 9.08303 9.08323 8.0622 8.54157 7.39553C8.20823 6.9997 7.6249 6.9997 7.29157 7.39553Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.52066 9.54123C7.04149 12.0412 6.64566 12.7079 7.58316 12.8746C8.14566 12.9996 12.9582 8.18706 12.8748 7.60373C12.729 6.62456 11.9998 7.04123 9.52066 9.54123Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.4582 11.5625C11.1457 11.9375 11.2499 12.5 11.729 12.7917C12.4374 13.25 13.2499 12.2292 12.7082 11.5625C12.3749 11.1667 11.7915 11.1667 11.4582 11.5625Z",
    fill: fill
  }));
};

exports["default"] = _default;